// src/utils/constants.ts

import { CategoryInfo, Occasion, SortOption } from '../types';

const _waNum = process.env.REACT_APP_WHATSAPP_NUMBER ?? '9056609810';
export const WHATSAPP_NUMBER  = `91${_waNum}`;        // wa.me format: 919056609810
export const WHATSAPP_DISPLAY = `+91 ${_waNum}`;      // display: +91 9056609810
export const WHATSAPP_PHONE   = `+91-${_waNum}`;      // schema/SEO: +91-9056609810

export const WHATSAPP_URL = (message = 'Hi! I am interested in your products.'): string =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

// Local image fallback — via.placeholder.com is a dead service
export const PLACEHOLDER_IMG: string =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400" viewBox="0 0 400 400">` +
    `<rect width="400" height="400" fill="#f5efe4"/>` +
    `<g fill="none" stroke="#a47c4a" stroke-width="2" opacity="0.5">` +
    `<rect x="140" y="130" width="120" height="120" rx="4"/>` +
    `<circle cx="175" cy="165" r="12"/>` +
    `<path d="M140 225 L180 190 L210 215 L235 195 L260 218"/>` +
    `</g>` +
    `<text x="200" y="290" font-family="Jost,sans-serif" font-size="14" fill="#a47c4a" text-anchor="middle" opacity="0.7">Image unavailable</text>` +
    `</svg>`
  );

export const CATEGORIES: CategoryInfo[] = [
  { name: 'Kurta',             emoji: '👘', desc: 'Elegant daily wear'   },
  { name: 'Suits',             emoji: '🥻', desc: 'Salwar & Kameez'      },
  { name: 'Palazzo Sets',      emoji: '👗', desc: 'Flowy & stylish'      },
  { name: 'Velvet Collection', emoji: '✨', desc: 'Premium velvet'       },
  { name: 'Woolen',            emoji: '🧶', desc: 'Winter warmth'        },
  { name: 'Coord Sets',        emoji: '💃', desc: 'Trendy co-ords'       },
];

export const SORT_OPTIONS: { value: SortOption; label: string }[] = [
  { value: 'newest',     label: 'Newest First'        },
  { value: 'price_asc',  label: 'Price: Low to High'  },
  { value: 'price_desc', label: 'Price: High to Low'  },
];

export const ALL_CATEGORIES: string[] = [
  'All', 'Kurta', 'Suits', 'Palazzo Sets', 'Coord Sets',
  'Velvet Collection', 'Woolen', 'Dresses', 'Bottoms', 'Others',
];

// Category name <-> URL slug (e.g. 'Palazzo Sets' <-> 'palazzo-sets') —
// used for /products/:category path routes instead of ?category= query
// params, so category pages are real, distinct, crawlable/prerenderable URLs.
export const slugifyCategory = (name: string): string =>
  name.toLowerCase().replace(/\s+/g, '-');

export const categoryFromSlug = (slug: string): string | undefined =>
  ALL_CATEGORIES.find((c) => slugifyCategory(c) === slug.toLowerCase());

export const OCCASIONS: Occasion[] = [
  'Casual', 'Office', 'Festive', 'Wedding', 'Party',
];

export const CHAT_SUGGESTIONS: string[] = [
  'Show kurtas under ₹1000',
  'Size guide',
  'WhatsApp enquiry',
  'New arrivals',
];

export const AI_SEARCH_SUGGESTIONS: string[] = [
  'Red velvet kurta for wedding',
  'Palazzo set under ₹1200',
  'Warm woolen suit for winter',
  'Cotton kurti for daily wear',
  'Ethnic coord set for party',
];

export const PRICE_PRESETS: { label: string; min: string; max: string }[] = [
  { label: 'Under ₹800',  min: '',    max: '800'  },
  { label: '₹800–1500',   min: '800', max: '1500' },
  { label: '₹1500+',      min: '1500',max: ''     },
];
